<template>
  <div class="container service">
    <div class="row">
      <h1>{{ service.title }}</h1>
    </div>
    <div class="row row-centered">
      <div v-for="(item, key) in service.items" v-bind:key="key" class="col-sm-3 col-md-3 col-centered">
        <ServiceItem :item="item"></ServiceItem>
      </div>
      <p class="about">{{ service.info }}</p>
    </div>
  </div>
</template>

<script>
  import Icon from 'vue-awesome/components/Icon'
  import ServiceItem from './ServiceItem'
  import getMeta from '../common/js/get-meta'
  import 'vue-awesome/icons/wrench'
  export default {
    props: ['service', 'windowWidth'],
    mixins: [getMeta],
    components: {
      Icon,
      ServiceItem
    },
    data () {
      return {
        show: false
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import '../common/css/vars'

.fa-icon
  width auto
  height 2em
  max-width 100%
  max-height 100%
  margin 10px 0

hr
  border none
  height 2px
  background-color #333
  margin 0

h1
  font-size 16px
  font-weight 600

.gradient
  background radial-gradient(ellipse at center, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%)

.service
  padding 15px

.subservice
  background-color #1b1e22
  border 2px solid #333
  max-width 180px
  margin 15px auto
  box-shadow 4px 4px 2px rgba(150, 150, 150, 1)

.title
  padding 10px 2px

.about
  padding 10px
</style>



// WEBPACK FOOTER //
// Service.vue?532f50eb